import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0637a3bc = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _0c5d22ba = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _0d82129a = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _5ec3be41 = () => interopDefault(import('..\\pages\\enroll\\eligibility.vue' /* webpackChunkName: "pages_enroll_eligibility" */))
const _4896cd98 = () => interopDefault(import('..\\pages\\enroll\\patient-information.vue' /* webpackChunkName: "pages_enroll_patient-information" */))
const _ddbdc492 = () => interopDefault(import('..\\pages\\enroll\\success.vue' /* webpackChunkName: "pages_enroll_success" */))
const _00ea797a = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _00ce4a78 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _0095ec74 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _0079bd72 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _3470fe84 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _8dc3e028 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _0637a3bc,
    name: "error"
  }, {
    path: "/rejection",
    component: _0c5d22ba,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _0d82129a,
    name: "unlock"
  }, {
    path: "/enroll/eligibility",
    component: _5ec3be41,
    name: "enroll-eligibility"
  }, {
    path: "/enroll/patient-information",
    component: _4896cd98,
    name: "enroll-patient-information"
  }, {
    path: "/enroll/success",
    component: _ddbdc492,
    name: "enroll-success"
  }, {
    path: "/errors/400",
    component: _00ea797a,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _00ce4a78,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _0095ec74,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _0079bd72,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _3470fe84,
    name: "errors-500"
  }, {
    path: "/",
    component: _8dc3e028,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
